import { UserContext, UserMutations } from "./types";
import { User, UserProfileSchema } from "@/models/user/user";

export const addUser = (context: UserContext, userData: User | null) => {
  context.commit(UserMutations.SetUser, userData);
};

export const updateUserProfile = (context: UserContext, userProfileData: UserProfileSchema) => {
  context.commit(UserMutations.SetUserProfile, userProfileData);
};

export const addFileId = (context: UserContext, name: string | null) => {
  context.commit(UserMutations.SetFileId, name);
};
